import { Alert, Box, Stack, Typography } from "@mui/material"
import { DialogBox } from "lib/@components/dialogBox"
import { OkCancel } from "lib/@components/okCancel"
import { Repeat } from "lib/@components/repeat"
import { UnappliedGroupLink } from "./unapplied-group-link"

export function UnappliedGroupsWarningDialog({ groups = [], projectId }) {
    return (
        <DialogBox
            title="Unapplied Group Changes"
            value={true}
            Actions={OkCancel}
            okCaption="Submit Anyway"
            cancelCaption="Cancel"
            data-cy="unapplied-groups-warning-dialog"
        >
            <Stack spacing={2} sx={{ mt: 1 }}>
                <Alert severity="warning" data-cy="unapplied-groups-warning">
                    This schedule belongs to {groups.length > 1 ? "groups" : "a group"} with unapplied changes. These
                    changes will not be included in the review.
                </Alert>
                <Box sx={{ p: 2, borderRadius: 1, bgcolor: "action.hover" }}>
                    <Repeat list={groups} item={<UnappliedGroupLink projectId={projectId} />} pass="group" />
                </Box>
                <Typography variant="body2" color="text.secondary">
                    Either apply the group changes or remove the schedule from the{" "}
                    {groups.length > 1 ? "groups" : "group"} before submitting, or continue to submit without these
                    changes.
                </Typography>
            </Stack>
        </DialogBox>
    )
}
